import { CarouselButtons, Stack, XStack, YStack, useCarousel } from '@my/ui'
import { BlockTitle } from 'app/components'
import { BrandOfferCollectionBlock } from './brand-offer-collection.block'
import { BrandOfferCollectionItem } from './brand-offer-collection-item'

export const BrandOfferCollectionComponent = (block: BrandOfferCollectionBlock) => {
  const carousel = useCarousel()

  return (
    <YStack flex={1} height="100%" gap="$4">
      {block.title && <BlockTitle>{block.title}</BlockTitle>}
      <Stack
        py="$3"
        my="$-3"
        className="overflow-x-hidden"
        position="relative"
        w="100%"
        ref={carousel.emblaRef as any}
      >
        <XStack gap="$3.5" height="auto">
          {block.offers &&
            block.offers.map((offer) => (
              <Stack
                key={offer.id}
                w="70%"
                $gtXss={{
                  w: '40%',
                }}
                $gtSm={{
                  w: 'calc(33.33% - 8px)',
                }}
              >
                <BrandOfferCollectionItem offer={offer} />
              </Stack>
            ))}
        </XStack>
        <CarouselButtons
          carousel={carousel}
          buttonProps={{
            $xs: {
              display: 'none',
            },
          }}
        />
      </Stack>
    </YStack>
  )
}
